<template>
  <div>
    <v-dialog persistent v-model="showUnsavedChangesInterceptor" width="500">
      <v-card>
        <v-card-text>You have unsaved changes. Would you like to save your changes?</v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="info" text @click="saveChanges()">Save</v-btn>
          <v-btn text @click="discardChanges()">Discard</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    showUnsavedChangesInterceptor: Boolean,
    editedoldtab: Object,
    uneditedoldtab: Object,
    closedTab: [Boolean,Object]
  },
  data() {
    return {
      dialog: this.showUnsavedChangesInterceptor,
    };
  },
  methods: {
    saveChanges() {
      return this.$emit("saveChanges", this.closedTab);
    },
    discardChanges() {
    
      if(this.closedTab){
        
        return this.$emit('discardChangesAndCloseTab', this.closedTab)
      }
      
      let oldtabpackage = [this.editedoldtab, this.uneditedoldtab];
      this.$emit("discardChanges", oldtabpackage);
    },
  },
};
</script>

<style>
</style>